import React from 'react';

import { InputOption } from 'components/common/MyCustomSelect/components/InputOption/InputOption';
import { ValueContainer } from 'components/common/MyCustomSelect/components/ValueContainer/ValueContainer';

import { Select } from 'components/DesignSystem/Select';
import { Switch } from 'components/DesignSystem/Switch';
import { statusOptions } from 'components/widgets/KeyActivities/components/filter.utils';

import classes from './LocalFilters.module.scss';

interface Props {
    status: readonly ISelectOption<string>[];
    setStatus: (value: readonly ISelectOption<string>[]) => void;
    isCriticalPath: boolean;
    setIsCriticalPath: (value: boolean) => void;
}

export const LocalFilters = ({ isCriticalPath, setIsCriticalPath, status, setStatus }: Props) => {
    return (
        <div className={classes.localFilters}>
            <div className={classes.filterItem}>
                <div className={classes.title}>Status</div>
                <Select<ISelectOption<string>, true>
                    value={status}
                    onChange={setStatus}
                    options={statusOptions}
                    isClearable={true}
                    closeMenuOnSelect={false}
                    hideSelectedOptions={false}
                    isMulti={true}
                    placeholder={'Select Status...'}
                    components={{
                        Option: InputOption,
                        ValueContainer: ValueContainer,
                    }}
                />
            </div>
            <div className={classes.filterItem}>
                <Switch
                    checked={isCriticalPath}
                    onChange={(event) => {
                        const isChecked = event.target.checked;
                        setIsCriticalPath(isChecked);
                    }}
                    label={'Critical Path Only'}
                    labelPlacement={'start'}
                />
            </div>
        </div>
    );
};
